/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Assetinfo_Linux1Inputs */

const id_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk sistem operasi berbasis Linux.`)
};

const ms_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk sistem pengendalian berasaskan Linux.`)
};

const da_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Til Linux-baserede operativsystemer.`)
};

const de_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Linux-basierte Betriebssysteme.`)
};

const en_us2_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Linux-based operating systems.`)
};

const es_es2_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sistemas operativos basados en Linux.`)
};

const es_mx2_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sistemas operativos basados en Linux.`)
};

const fil_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sa mga operating system na batay sa Linux.`)
};

const fr_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les systèmes d'exploitation basés sur Linux.`)
};

const it_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per sistemi operativi basati su Linux.`)
};

const hu_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux alapú operációs rendszerekhez.`)
};

const nl_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor Linux-gebaseerde besturingssystemen.`)
};

const no_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Linux-baserte operativsystemer.`)
};

const pl_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla systemów operacyjnych opartych na Linux.`)
};

const pt_br2_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sistemas operacionais baseados em Linux.`)
};

const pt_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sistemas operativos baseados em Linux.`)
};

const ro_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pentru sisteme de operare bazate pe Linux.`)
};

const fi_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux-pohjaisille käyttöjärjestelmille.`)
};

const sv_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För Linux-baserade operativsystem.`)
};

const vi_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dành cho hệ điều hành dựa trên Linux.`)
};

const tr_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux tabanlı işletim sistemleri için.`)
};

const cs_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro operační systémy založené na Linuxu.`)
};

const bg_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За операционни системи, базирани на Linux.`)
};

const ru_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для операционных систем на базе Linux.`)
};

const uk_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для операційних систем на базі Linux.`)
};

const ar_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لأنظمة التشغيل القائمة على Linux.`)
};

const hi_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux-आधारित OS के लिए।`)
};

const th_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับระบบปฏิบัติการที่ใช้ Linux`)
};

const ja_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux ベースのオペレーティングシステム向け。`)
};

const zh_cn2_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于基于 Linux 的操作系统。`)
};

const zh_hant1_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適用於基於 Linux 的作業系統。`)
};

const ko_misc_downloads_assetinfo_linux1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Linux1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux 기반 운영 체제용.`)
};

/**
* | output |
* | --- |
* | "For Linux-based operating systems." |
*
* @param {Misc_Downloads_Assetinfo_Linux1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_assetinfo_linux1 = /** @type {((inputs?: Misc_Downloads_Assetinfo_Linux1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Assetinfo_Linux1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "ms") return ms_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "da") return da_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "de") return de_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "fil") return fil_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "fr") return fr_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "it") return it_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "hu") return hu_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "nl") return nl_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "no") return no_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "pl") return pl_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "pt") return pt_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "ro") return ro_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "fi") return fi_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "sv") return sv_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "vi") return vi_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "tr") return tr_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "cs") return cs_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "bg") return bg_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "ru") return ru_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "uk") return uk_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "ar") return ar_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "hi") return hi_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "th") return th_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "ja") return ja_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_assetinfo_linux1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_assetinfo_linux1(inputs)
	return ko_misc_downloads_assetinfo_linux1(inputs)
});
export { misc_downloads_assetinfo_linux1 as "misc.downloads.assetInfo.linux" }